import { useState, useMemo } from 'react';
import { useProjectSiteParams } from '@/shared/lib';
import { useGetConsignmentHistoryQuery } from '@/entities/consignments';

import { HISTORY_TYPE_LOOKUP, type HistoryTypeLookupKey } from './constants';
import type { HistoryFilters } from './types';

export function useConsignmentHistory(consignmentId: string, isOpen: boolean) {
  const { projectId, siteId } = useProjectSiteParams();
  const [filters, setFilters] = useState<HistoryFilters>({
    showStatus: false,
    showPriority: false
  });

  const historyType = useMemo(() => {
    const key = `${Number(filters.showStatus)}${Number(filters.showPriority)}` as HistoryTypeLookupKey;
    return HISTORY_TYPE_LOOKUP[key];
  }, [filters.showStatus, filters.showPriority]);

  const { data, isLoading } = useGetConsignmentHistoryQuery(
    {
      id: consignmentId,
      projectId,
      siteId,
      type: historyType
    },
    {
      skip: !isOpen || !historyType
    }
  );

  const updateFilter = (filterName: keyof HistoryFilters, value: boolean) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value
    }));
  };

  return {
    data,
    filters,
    updateFilter,
    isLoading,
    hasFilter: !!historyType
  };
}
